/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "employee-cms";

export type employeeParam = {
  search?: string;
  id_department?: number;
  id_position?: number;
  end_date?: string;
  sortType?: string;
  sortBy?: string;
  limit: number;
  page: number;
};

export interface Employee {
  id_employee: number;
  employee_no: string;
  employee_name: string;
  employee_last_name: string;
  position_name: string | null;
  department_name: string | null;
  status: string;
  created_by: string | null;
  created_date: string | null;
  modified_by: string | null;
  modified_date: string | null;
}

export interface EmployeeDetail {
  e_id_employee: number;
  ep_id_employee_picture: number;
  ep_employee_file: string;
  ep_employee_type: string;
  ep_employee_path: string;
  ep_employee_size: string;
  ep_status: string;
  id_employee: number;
  employee_no: string;
  employee_name: string;
  employee_last_name: string;
  employee_fullname?: string;
  id_position: number;
  id_company: number;
  id_department: number;
  sex: string;
  job: string;
  department_name: string;
  position_name: string;
  company_name_th: string;
  company_name_eng: string;
  employee_tel: string;
  employee_mobile: string;
  employee_fax: string;
  employee_email: string;
  status: string;
  id_employee_ref: number | null;
  id_roles: number | null;
  roles_name?: string;
  id_zone: number | null;
  id_warehouse: number | null;
  warehouse_name?: string;
  warehouse_no?: string;
}

export class EmployeesCMSApi extends BaseAPI {
  static getEmployeeList(params: employeeParam): Promise<AxiosResponse> {
    return this.api.get(`${path}`, { params: { ...params } });
  }
  static getDetailEmployee(id_employee: any): Promise<any> {
    return this.api.get(`${path}/${id_employee}`);
  }
  static createEmployee(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
  static updateEmployee(id_employee: any, body: any): Promise<any> {
    return this.api.patch(`${path}/${id_employee}`, body);
  }
  static deleteEmployee(id_employee: number): Promise<any> {
    return this.api.delete(`${path}/${id_employee}`);
  }
  static pictureUpload(file: any, id_employee: any): Promise<any> {
    const formData = new FormData();
    formData.append("file", file);
    return this.api.post(`${path}/${id_employee}/file`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  static pictureDownload(
    id_employee: any,
    id_employee_image: number
  ): Promise<any> {
    return this.api.get(`${path}/${id_employee}/file/${id_employee_image}`, {
      responseType: "blob",
    });
  }
}
